import { Ward } from "src/app/models/related-users.model";

export enum RelationshipType {
  ASC = "Associate",
  BRO = "Brother",
  CGV = "Care giver",
  CHD = "Child",
  DEP = "Handicapped dependent",
  DOM = "Life partner",
  EMC = "Emergency contact",
  EME = "Employee",
  EMR = "Employer",
  EXF = "Extended family",
  FCH = "Foster child",
  FND = "Friend",
  FTH = "Father",
  GCH = "Grandchild",
  GRD = "Guardian",
  GRP = "Grandparent",
  MGR = "Manager",
  MTH = "Mother",
  NCH = "Natural child",
  NON = "None",
  OAD = "Other adult",
  OTH = "Other",
  OWN = "Owner",
  PAR = "Parent",
  SCH = "Stepchild",
  SEL = "Self",
  SIB = "Sibling",
  SIS = "Sister",
  SPO = "Spouse",
  TRA = "Trainer",
  UNK = "Unknown",
  WRD = "Ward of court",
}

/**
 * This produces:
 * [
 *   { code: 'ASC', description: 'Associate' },
 *   { code: 'BRO', description: 'Brother' },
 *   ...
 * ]
 *
 */
export const RelationshipTypeOptions = Object.entries(RelationshipType).map(
  ([key, value]) => ({
    code: key,
    description: value,
  }),
);

export const isHandicapped = (
  wardRelationshipCode: keyof typeof RelationshipType,
): boolean => {
  const handicapped: string[] = ["wrd", "dep"];
  return handicapped.includes(wardRelationshipCode?.toLowerCase());
};


export const isVerifiedWard = (ward: Ward): boolean => {
  return ward.isVerified && !ward.isAdult;
};
